module.exports = __webpack_public_path__ + "static/logo-52b0f5bd489c72891c21c9f3e123e12d.svg";